import React from "react";

// * Components
import Book from "../../components/Book-Section/Book";
import PageInfo from "../../components/Products-Info-Section/PageInfo";

// * Datas
import { Fantasies } from "../../Data/ProductData";
import { homeObjOne } from "./Data";

function Fantasy() {
  return (
    <>
      <PageInfo {...homeObjOne} />
      <Book items={Fantasies} />
    </>
  );
}

export default Fantasy;
